import { render, staticRenderFns } from "./AttachmentRestrictionsConfigs.vue?vue&type=template&id=925315da&"
import script from "./AttachmentRestrictionsConfigs.vue?vue&type=script&lang=js&"
export * from "./AttachmentRestrictionsConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports